module.exports = __webpack_public_path__ + "assets/img/bank.88217792.jpg";